/** Per-column width cap so N columns never exceed 100% of the block. */
export function maxColumnWidthPct(columns) {
  const cols = Number(columns) || 1;
  return Math.round((100 / cols) * 2) / 2;
}

export function clampColumnWidthPct(val, columns) {
  const max = maxColumnWidthPct(columns);
  const n = Number(val);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(n, max);
}
